export default __webpack_public_path__ + "static/media/PhD_defense.dfabb728.jpg";